import {
  Typenames,
  V2ARecipientSearchResult,
} from '@varo/graphql-schema-types';
import { AllRecipients } from 'features/v2a/sender/helpers/Sender.helpers';
import { useEffect, useState } from 'react';
import GetV2ARecipientSearch from 'services/graphql/queries/MoveMoney/V2ARecipientSearch';
import {
  ErrorScreenProps,
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const useSearchRecipient = () => {
  const [recipients, setRecipients] = useState<AllRecipients>();
  const [searchPhrase, setSearchPhrase] = useState<string>('');
  const [pauseQuery, setPauseQuery] = useState<boolean>(true);
  const [error, setError] = useState<ErrorScreenProps>();

  const [{ data, fetching, error: userSearchError }] = useQuery<{
    v2aRecipientSearch: V2ARecipientSearchResult;
  }>({
    query: GetV2ARecipientSearch,
    variables: {
      searchTerm: searchPhrase,
    },
    requestPolicy: 'network-only',
    pause: pauseQuery,
  });

  useEffect(() => {
    if (data) {
      if (
        data?.v2aRecipientSearch.__typename ===
        Typenames.V2ARecipientSearchSuccess
      ) {
        setRecipients(data.v2aRecipientSearch.recipient);
      }
      if (
        data?.v2aRecipientSearch.__typename ===
        Typenames.V2ARecipientSearchNotFound
      ) {
        setError({
          screenType: ErrorScreenType.Error,
          messageHeadline: data.v2aRecipientSearch.copy,
        });
      }
    }
    if (userSearchError) {
      setError({
        screenType: ErrorScreenType.Error,
        messageHeadline: userSearchError.name,
        messageBody: userSearchError.message,
      });
    }
  }, [data, userSearchError]);

  const searchUser = (searchPhrase: string) => {
    setSearchPhrase(searchPhrase);
    setPauseQuery(!pauseQuery);
  };
  return { recipients, fetching, error, searchUser };
};

export default useSearchRecipient;
